export default __webpack_public_path__ + "static/media/github-purple.bd2e4eeb.svg";